import React, {useState, useRef, useEffect} from 'react';
import * as JZZ from 'jzz';
// import { Piano, KeyboardShortcuts, MidiNumbers } from 'react-piano';
import Button from '@material-ui/core/Button';
import firebaseConfig from './key'
import * as firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/auth'
import './App.css'

function App() {
  
  // const firstNote = MidiNumbers.fromNote('c3');
  // const lastNote = MidiNumbers.fromNote('f5');
  // const keyboardShortcuts = KeyboardShortcuts.create({
  //   firstNote: firstNote,
  //   lastNote: lastNote,
  //   keyboardConfig: KeyboardShortcuts.HOME_ROW,
  // });

  const randn_bm = (min, max, skew) => {
    let u = 0, v = 0;
    while(u === 0) u = Math.random(); //Converting [0,1) to (0,1)
    while(v === 0) v = Math.random();
    let num = Math.sqrt( -2.0 * Math.log( u ) ) * Math.cos( 2.0 * Math.PI * v );

    num = num / 10.0 + 0.5; // Translate to 0 -> 1
    if (num > 1 || num < 0) num = randn_bm(min, max, skew); // resample between 0 and 1 if out of range
    num = Math.pow(num, skew); // Skew
    num *= max - min; // Stretch to fill range
    num += min; // offset to min
    return num;
  }

  const db = useRef()
  // const jzz = JZZ().or('Cannot start MIDI engine!').openMidiOut();

  useEffect(()=>{

    console.log(JZZ().info())

    navigator.requestMIDIAccess().then(function(webmidi) {
      webmidi.outputs.forEach(function(port) { console.log('MIDI Out:', port.name); });
      webmidi.inputs.forEach(function(port) { console.log('MIDI In:', port.name); });
    }, function(err) {
      console.log('Cannot start WebMIDI!');
      if (err) console.log(err);
    }
  );

    firebase.initializeApp(firebaseConfig);
    db.current = firebase.firestore();
    db.current.collection("users").doc("a")
    .onSnapshot(function(doc) {
        const jzz = JZZ().or('Cannot start MIDI engine!').openMidiOut(0).or('Cannot open MIDI Out port!');
        let m = parseFloat(doc.data()["midi"])
        let midi = isNaN(m) ? 0 : m
        let v = parseFloat(doc.data()["vel"])
        let vel = isNaN(v) ? 0 : v
        jzz.send([0x90, midi ,vel])
        // console.log("Current data: ", );
    });

    db.current.collection("users").doc("b")
    .onSnapshot(function(doc) {
        const jzz = JZZ().or('Cannot start MIDI engine!').openMidiOut(1).or('Cannot open MIDI Out port!');
        let m = parseFloat(doc.data()["midi"])
        let midi = isNaN(m) ? 0 : m
        let v = parseFloat(doc.data()["vel"])
        let vel = isNaN(v) ? 0 : v
        jzz.send([0x90, midi ,vel])
        // console.log("Current data: ", );
    });

    db.current.collection("users").doc("c")
    .onSnapshot(function(doc) {
        const jzz = JZZ().or('Cannot start MIDI engine!').openMidiOut(2).or('Cannot open MIDI Out port!');
        let m = parseFloat(doc.data()["midi"])
        let midi = isNaN(m) ? 0 : m
        let v = parseFloat(doc.data()["vel"])
        let vel = isNaN(v) ? 0 : v
        jzz.send([0x90, midi ,vel])
        // console.log("Current data: ", );
    });

    firebase.auth().signInAnonymously().catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // ...
    });
      
  },[])

  // const videoSource = "https://www.uio.no/english/for-employees/unitpages/hf/ritmo/ritmo-essentials/ritmo-logo/animation/loop/ritmo-loop-white-hd.mp4"
  
  return (
    <div>
{/*     
    <video id="background-video" loop autoPlay>
        <source src={videoSource} type="video/mp4" />
        Your browser does not support the video tag.
    </video> */}

    <div className="main">
      <div>
        <p>Control Dr. Squiggles to interact with self-playing guitars:</p><br />
      </div>
      
      <Button variant="contained" color="primary"
        variant="contained"
        style={{borderRadius:0, width: 300}}
        onClick={() => {
          let midiNumber = Math.floor(Math.random() * 127);
          db.current.collection("users").doc("a").set({
            midi: Math.floor(randn_bm(0, 127, 1)),
            vel: Math.floor(randn_bm(0, 127, 1))
          })
          .then(function() {
              console.log("Document successfully written!");
          })
          .catch(function(error) {
              console.error("Error writing document: ", error);
          });
        }}
      >Ding Dr.Squiggles A</Button>
      <br /><br />
      <Button variant="contained" color="secondary"
        variant="contained"
        style={{borderRadius:0, width: 300}}
        onClick={() => {
          let midiNumber = Math.floor(Math.random() * 127);
          db.current.collection("users").doc("b").set({
            midi: Math.floor(randn_bm(0, 127, 1)),
            vel: Math.floor(randn_bm(0, 127, 1))
          })
          .then(function() {
              console.log("Document successfully written!");
          })
          .catch(function(error) {
              console.error("Error writing document: ", error);
          });
        }}
      >Ding Dr.Squiggles B</Button>
      <br /><br />
      <Button variant="contained"
        variant="contained"
        style={{borderRadius:0, width: 300}}
        onClick={() => {
          db.current.collection("users").doc("c").set({
            midi: Math.floor(randn_bm(0, 127, 1)),
            vel: Math.floor(randn_bm(0, 127, 1))
          })
          .then(function() {
              console.log("Document successfully written!");
          })
          .catch(function(error) {
              console.error("Error writing document: ", error);
          });
        }}
      >Ding Dr.Squiggles C</Button>
      <br /><br />
      <div>
        <p>The sound you make can be heard through <a href="https://uio.zoom.us/j/67143326665" rel="noopener noreferrer" target="_blank">this Zoom link</a>.</p>
        
      </div>
      {/* <div className="iframe-container">
        <iframe allow="microphone; camera"
          style={{width:900, height: 600}}
          src="https://success.zoom.us/wc/join/67143326665"
          frameborder="0">
        </iframe>
      </div> */}
    </div>
    </div>
  );
}

export default App;